exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{margin:0;font-family:Noto Sans,sans-serif;font-size:16px;-webkit-font-smoothing:antialiased}h1{color:#00aeef}h1,h2,h3{font-family:Montserrat,sans-serif;font-weight:700}h2,h3{color:#333}a{color:#00aeef}.app__topBar___1dX2D{width:100%;height:20px;background-color:#00aeef}.app__topBar___1dX2D nav{position:relative;z-index:10}.app__app___2x2p5{padding:20px 30px 0}.app__app___2x2p5 header h1{margin:0;margin-bottom:15px}.app__app___2x2p5 .app__languageSwitcherContainer___1WwHN{float:right}.app__logo___2UvEZ{height:25px;margin-right:25px}.app__logo360Container___1Y79x{display:inline-block}.app__logo360Container___1Y79x span{display:none}@media (min-width:768px){.app__logo360Container___1Y79x span{display:block}}.app__logo360___2kKNO{width:140px}.app__orange___FHahu{color:#fb7b00}.app__targetName___17vLw{padding:20px 0;border-bottom:1px solid #eee}@media (min-width:768px){.app__targetName___17vLw{float:right;margin-right:20px;border:0;padding:0}}", ""]);

// exports
exports.locals = {
	"topBar": "app__topBar___1dX2D",
	"app": "app__app___2x2p5",
	"languageSwitcherContainer": "app__languageSwitcherContainer___1WwHN",
	"logo": "app__logo___2UvEZ",
	"logo360Container": "app__logo360Container___1Y79x",
	"logo360": "app__logo360___2kKNO",
	"orange": "app__orange___FHahu",
	"targetName": "app__targetName___17vLw"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/components/styles/app.scss
// module id = 1062
// module chunks = 0